module.exports = __webpack_public_path__ + "img/maintop.a2f9215.png";